import { IEmployeeOrder } from 'graphql/types';

export const INVITATION_OVERVIEW_VARIABLES = {
    offset: 0,
    limit: 25,
    orderBy: IEmployeeOrder.UpdatedAt,
    ascending: false,
    search: '',
};
